@use "../../../../../../../styles/Constants.scss" as Constants;
@use "../../../../../../../styles/Colors.scss" as Colors;

$content-height: 450px;

.modalBody {
	max-height: unset;
}

.modal {
	max-height: 90vh;
}

.dialog {
	padding-top: 5vh;
}

.instructions {
	font-size: Constants.$val-fontSizeBig;
	line-height: 24px;
	margin-bottom: Constants.$val-spacing-s;
}

.totalSelectedContainer {
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
	margin-bottom: Constants.$val-spacing-s;
	.counters {
		display: flex;
		flex-direction: row;
		align-items: center;
	}
	.totalSelectedCounter {
		font-size: Constants.$val-fontSizeRegular;
		line-height: Constants.$val-lineHeightRegular;
		margin-right: Constants.$val-spacing-s;
		font-weight: 500;
	}

}


.content {
	display: flex;
	flex-direction: row;
	align-items: stretch;
	height: $content-height;
	border: solid 1px Colors.$col-lighterGrey;
	border-radius: 2px;

	.materialsList {
		flex: 1;
	}
}

.footer {
	flex-direction: row;
	justify-content: space-between;
	align-items: center;

	&::before, &::after {
		display: none;
	}

	.actionGroup {
		display: flex;
		flex-direction: row;
		align-items: center;
		gap: Constants.$val-spacing-m;
	}
}
